var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-title",
    on: {
      click: function click($event) {
        _vm.isClose = !_vm.isClose;
      }
    }
  }, [_c("i", {
    staticClass: "icon-arrow"
  }, [_c("svg", {
    staticClass: "arrow",
    class: {
      close: _vm.isClose
    },
    attrs: {
      viewBox: "0 0 1024 1024",
      "data-icon": "caret-down",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false"
    }
  }, [_c("path", {
    attrs: {
      d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
    }
  })])]), _c("span", {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c("transition", {
    attrs: {
      name: "slide-fade"
    }
  }, [_vm.isClose ? _c("div", {
    staticClass: "card-body"
  }, [_vm._t("default")], 2) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };